<template>
  <svg viewBox="0 0 690 239" xmlns="http://www.w3.org/2000/svg">
  <g id="boton1" class="fix-svg-origin animated fadeIn dura-1 hvr hvr-scale" @click="mostrar(1)">
    <circle class="cls-1" cx="115.21" cy="123.59" r="89.5" fill="#ddffa1"/>
    <path d="M115.59 37.1a86.5 86.5 0 0 1 0 173v6a92.5 92.5 0 0 0 0-185z" fill="#8ebc00"/>
    <path d="M115.49 210.09h-.28a86.5 86.5 0 0 1 0-173h.28v-6h-.28a92.5 92.5 0 0 0 0 185h.28z" fill="#ceef0f"/>
    <text class="cls-4" x="83.77" y="120.12" fill="#1e1e1e" font-family="MyriadPro-BoldCond, 'Myriad Pro'" font-size="21" font-weight="700">
      Mé<tspan class="cls-5" x="105.95" y="120.12" letter-spacing="-.01em">t</tspan><tspan x="112.35" y="120.12">odos</tspan><tspan x="82.03" y="140.12">análogos</tspan>
    </text>
  </g>
  <g id="boton2" class="fix-svg-origin animated fadeIn dura-2 hvr hvr-scale" @click="mostrar(2)">
    <circle class="cls-1" cx="343.5" cy="123.59" r="89.5" fill="#ddffa1"/>
    <path d="M414.87 74.73a86.493 86.493 0 0 1-142.3 98.36l-4.94 3.41A92.5 92.5 0 0 0 419.81 71.32z" fill="#ff801c"/>
    <path d="M272.51 173c-.06-.08-.11-.16-.17-.23a86.501 86.501 0 0 1 142.32-98.36c0 .08.1.16.16.24l4.93-3.42-.16-.23a92.5 92.5 0 1 0-152.18 105.19l.16.23z" fill="#ffe300"/>
    <text class="cls-4" x="312.05" y="119.59" fill="#1e1e1e" font-family="MyriadPro-BoldCond, 'Myriad Pro'" font-size="21" font-weight="700">
      Mé<tspan class="cls-5" x="334.23" y="119.59" letter-spacing="-.01em">t</tspan><tspan x="340.63" y="119.59">odos</tspan><tspan x="296.33" y="139.59" letter-spacing="-.01em">v</tspan><tspan x="304.33" y="139.59">olumétricos</tspan>
    </text>
  </g>
  <g id="boton3" class="fix-svg-origin animated fadeIn dura-3 hvr hvr-scale" @click="mostrar(3)">
    <circle class="cls-1" cx="569.6" cy="123.59" r="89.5" fill="#ddffa1"/>
    <path d="M629.19 186.29A86.5 86.5 0 0 1 509.45 61.43l-4.15-4.33a92.5 92.5 0 0 0 128 133.52z" fill="#24bed3"/>
    <path d="M509.52 61.36l.21-.2A86.5 86.5 0 0 1 629.47 186l-.21.19 4.15 4.33.21-.19a92.5 92.5 0 1 0-128-133.53l-.2.2z" fill="#00fff2"/>
    <text class="cls-4" x="496.04" y="109.46" fill="#1e1e1e" font-family="MyriadPro-BoldCond, 'Myriad Pro'" font-size="21" font-weight="700">
      Mé<tspan class="cls-5" x="518.22" y="109.46" letter-spacing="-.01em">t</tspan><tspan x="524.62" y="109.46">odos basados en</tspan><tspan x="488.74" y="129.46">el comportamiento</tspan><tspan x="509.44" y="149.46"> de producción</tspan>
    </text>
  </g>
  <g>
      <foreignObject v-if="vistos[0]" x="100" y="20" width="25px" height="25px">
        <img src="../imagenes_compartidas/ok-bot.png" alt="">
      </foreignObject>
      <foreignObject v-if="vistos[1]" x="332" y="20" width="25px" height="25px">
        <img src="../imagenes_compartidas/ok-bot.png" alt="">
      </foreignObject>
      <foreignObject v-if="vistos[2]" x="560" y="20" width="25px" height="25px">
        <img src="../imagenes_compartidas/ok-bot.png" alt="">
      </foreignObject>
    </g>
</svg>
</template>
<script>
export default {
  props: ['vistos'],
  methods: {
    mostrar(id){
      this.$emit('openModal',id-1)
    }
  }
}
</script>

<style scoped>
  .cls-1{fill:#ddffa1}.cls-4{font-size:21px;fill:#1e1e1e;font-family:MyriadPro-BoldCond,Myriad Pro;font-weight:700}.cls-5{letter-spacing:-.01em}
</style>